import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import MAP_TYPE from '../../map_type';
import LabeledOption from '../react-labeled-option';

function MapFilters({currentMapType, changeMapType, isMultiSelectOn = false, toggleMultiSelect}) {
  const selectBySection = (
    <LabeledOption
      onClick={(event) => {
        changeMapType(event, MAP_TYPE.SECTION);
      }}
      selected={currentMapType && currentMapType === MAP_TYPE.SECTION}
      label={<FormattedMessage id="ListingsFilter.mapFilters.Select_By_Section" defaultMessage="Select by Sections" />}
      typeOfInput="Radio"
      id="MapFilter__SectionId"
      name="MapFilter"
    />
  );

  const selectByZone = (
    <LabeledOption
      onClick={(event) => {
        changeMapType(event, MAP_TYPE.ZONE);
      }}
      selected={currentMapType && currentMapType === MAP_TYPE.ZONE}
      label={<FormattedMessage id="ListingsFilter.mapFilters.Select_By_Zone" defaultMessage="Select by Zone" />}
      typeOfInput="Radio"
      id="MapFilter__ZoneId"
      name="MapFilter"
    />
  );

  const controlMultiSelect = (
    <LabeledOption
      onClick={(event) => {
        event.preventDefault();
        toggleMultiSelect(event);
      }}
      selected={isMultiSelectOn}
      label={<FormattedMessage id="ListingsFilter.mapFilters.Multi_Selection" defaultMessage="Allow Multi-Selection" />}
      typeOfInput="Toggle"
      id="MapFilter__MultiSelectToggle"
    />
  );

  return (
    <section className="ListingsFilter__sectionContainer">
      <h3 className="ListingsFilter__sectionContainer__Header">
        <FormattedMessage defaultMessage="Seat Map Options" id="ListingsFilter.mapFilters" />
      </h3>
      {selectBySection}
      {selectByZone}
      <hr className="EventRoyal__border" />
      {controlMultiSelect}
    </section>
  );
}

MapFilters.propTypes = {
  currentMapType: PropTypes.string,
  changeMapType: PropTypes.func,
  isMultiSelectOn: PropTypes.bool,
  toggleMultiSelect: PropTypes.func,
};

export default MapFilters;
